<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row class="pa-2">
                                    <v-col cols="12">
                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="sale_invoice_delivery_master_id.value.value"
                                            :items="getInvSalesInvoiceDeliveryList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            @update:modelValue="onSaleInvoiceDeliveryChange"
                                            :error-messages="sale_invoice_delivery_master_id.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="requisitionDisable"
                                            :loading="saleInvoiceLoading"
                                            clearable
                                        >
                                            <template #label>
                                                Sale Invoice Delivery
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-date-input
                                            label="Gate Pass Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="gate_pass_date.value.value"
                                            :error-messages="gate_pass_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Gate Pass Date
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-date-input>

                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="customer_id.value.value"
                                            :items="getCustomerList"
                                            :item-title="(item) => `${item.company_name}`"
                                            item-value="id"
                                            :error-messages="customer_id.errorMessage.value"
                                            autocomplete="off"
                                            :loading="customerLoading"
                                            clearable
                                        >
                                            <template #label>
                                                Customer
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-text-field
                                            label="Driver Name"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="driver_name.value.value"
                                            :error-messages="driver_name.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Driver Name
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-text-field>

                                        <v-text-field
                                            label="transporter_name"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="transporter_name.value.value"
                                            :error-messages="transporter_name.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Vehicle No"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="vehicle_no.value.value"
                                            :error-messages="vehicle_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="mobile_no"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="mobile_no.value.value"
                                            :error-messages="mobile_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Item Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                    <!-- Cart Table -->
                                    <v-row class="pt-2">
                                        <v-col cols="12">
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-left" style="width: 25%">Product Name</th>
                                                        <th class="text-start" style="width: 25%">Product Code</th>
                                                        <th class="text-center" style="width: 15%">Delivery Qty.</th>
                                                        <th class="text-center" style="width: 15%">Unit</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                    v-for="(item, index) in cart"
                                                    v-if="cart.length > 0"
                                                    :key="index"
                                                    >
                                                        <td class="text-center py-1">{{ index + 1 }}</td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                            {{ item.product_name }}
                                                        </td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                            {{ item.product_code }} 
                                                        </td>
                                                        
                                                        <td class="text-center py-1">
                                                            {{ item.qty }}
                                                        </td>
                                                        
                                                        <td class="text-center py-1">
                                                            {{ item.unit_name }}
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                            <v-skeleton-loader
                                                                type="heading"
                                                                :loading="loading"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                            You have no item
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Description"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                            <v-btn
                                            class="bg-grey-darken-1 me-2"
                                            variant="flat"
                                            @click="submitForm(0)"
                                            >DRAFT</v-btn>
                                            <v-btn
                                            class="bg-primary"
                                            variant="flat"
                                            @click="submitForm(1)"
                                            >POST</v-btn>
                                            </v-layout>
                                        </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
    components: {},
    data: () => ({
        isEntryMode: true,
        panel: [0],
        panel2: [0],
        saleInvoiceLoading: false,
        customerLoading: false,
        errorMessages: "",
        visible: false,
        deliveryQtyDisable: false,
        requisitionDisable: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        if (this.$store.getters.getInvSalesInvoiceDeliveryList.length === 0) {
            this.saleInvoiceLoading = true;
            this.$store.dispatch("getInvSalesInvoiceDeliveryList").then((res) => {
                this.saleInvoiceLoading = false;
            });
        }
        if (this.$store.getters.getCustomerList.length === 0) {
            this.customerLoading = true;
            this.$store.dispatch("getCustomerList").then((res) => {
                this.customerLoading = false;
            });
        }
    },
    computed: {
        getInvSalesInvoiceDeliveryList() {
            return this.$store.getters.getInvSalesInvoiceDeliveryList;
        },
        getCustomerList() {
            return this.$store.getters.getCustomerList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) =>
                item.branch_id == this.$store.getters.getAuthUser.branch_id &&
                item.status == 1
            );
        },
    },
    methods: {
        async onSaleInvoiceDeliveryChange(selectedId) {
            if (!selectedId) {
                this.cart = []; 
                return;
            }

            try {
                const response = await this.$store.dispatch(
                    "getInvSalesInvoiceDeliveryById",
                    selectedId
                );
                
                this.customer_id.value.value = response.invoice_master.customer_id;
                this.cart = [];
                
                (response.invoice_delivery_details || []).forEach((item) => {

                    if (item.product) {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product.name || "",
                            product_code: item.product.code || "",
                            qty: item.qty,
                            unit_name: item.product.unit?.name || "",
                        });
                    }

                });
            } catch (error) {
                console.error("Error loading requisition:", error);
            }
        }
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                sale_invoice_delivery_master_id: yup.string().required().label("Sale Invoice Delivery"),
                customer_id: yup.string().required().label("Customer"),
                driver_name: yup.string().required().label("Driver Name"),
            }),
        });
        const gate_pass_master_id = useField("gate_pass_master_id");
        const sale_invoice_delivery_master_id = useField("sale_invoice_delivery_master_id");
        const product_id = useField("product_id");
        const gate_pass_date = useField("gate_pass_date");
        const customer_id = useField("customer_id");
        const driver_name = useField( "driver_name");
        const transporter_name = useField("transporter_name");
        const vehicle_no = useField("vehicle_no");
        const mobile_no = useField("mobile_no");
        const status = useField("status");
        
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {

            values.status = currentStatus.value;
            values.cart = cart.value;

            if(values.cart.length === 0){
                toast.error("Please add at least one item to the cart.");
                return;
            }

            store
            .dispatch("saveUpdateInvGatePass", values)
            .then((response) => {
                resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "gate-pass-record" });
                    }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });

        });
        return {
            submit,
            submitForm,
            gate_pass_master_id,
            sale_invoice_delivery_master_id,
            gate_pass_date,
            customer_id,
            driver_name,
            transporter_name,
            vehicle_no,
            mobile_no,
            product_id,
            remarks,
            cart,
            status,
            errorMessages,
            buttonText,
            loading,
        };
    },
    mounted() {

        const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'

        const id = this.$route.query.id;
        console.log(id)
        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                .dispatch("getInvGatePassById", id)
                .then((data) => {
                    console.log(data)
                    this.isEntryMode = false;
                    let gatePass = data;
                    this.gate_pass_master_id.value.value = gatePass.id;
                    this.sale_invoice_delivery_master_id.value.value = gatePass.sale_invoice_delivery_master_id;
                    this.gate_pass_date.value.value = gatePass.gate_pass_date
                    this.customer_id.value.value = gatePass.customer_id;
                    this.driver_name.value.value = gatePass.driver_name;
                    this.transporter_name.value.value = gatePass.transporter_name;
                    this.vehicle_no.value.value = gatePass.vehicle_no;
                    this.mobile_no.value.value = gatePass.mobile_no;

                    this.cart.value = [];
                    (gatePass.details || []).forEach((item) => {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product?.name || "",
                            product_code: item.product?.code || "",
                            qty: item.qty,
                            unit_id: item.product.unit?.id || "",
                            unit_name: item.product.unit?.name || "",
                        });
                    });
                    this.remarks.value.value = gatePass.remarks;
                    this.$store.commit("UNSET_LOADING");
                })
                .catch((error) => {
                    this.$store.commit("UNSET_LOADING");
                    console.error("Failed to fetch requisition:", error);
                });
            });
        } else {
            this.isEntryMode = true;
            this.gate_pass_date.value.value = today;
        }
    },
};
</script>
